import React from 'react';
import '../less/creditDeposit.less';
import hero_img from '../img/deposit_credit/hero_img.png';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import FilesForDownloadNew from "../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../auxiliary-components/shared/TextAboveFooterNew";
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import Advantages from '../../../auxiliary-components/shared/AdvantagesBlock';
import tariffsData from "../enums/deposit_credit_tariffs_data.json";
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';

export default function template() {
  const page = 'deposit-credit-new';

  const tabs = [{tab: 'get-services', title: 'DEPOSIT_CREDIT_NEW_TABS_TITLE_01'},
          {tab: 'payments', title: 'DEPOSIT_CREDIT_NEW_TABS_TITLE_02'}];

  const hero_data = {
    title: 'DEPOSIT_CREDIT_NEW_HERO_TITLE',
    text: 'DEPOSIT_CREDIT_NEW_HERO_TEXT',
  }

  const advantagesItems1 = [
    {
      title: 'DEPOSIT_CREDIT_NEW_CARDS_ADVANTAGES_TITLE_01',
      text: 'DEPOSIT_CREDIT_NEW_CARDS_ADVANTAGES_TEXT_01',
    },
    {
      title: 'DEPOSIT_CREDIT_NEW_CARDS_ADVANTAGES_TITLE_02',
      text: 'DEPOSIT_CREDIT_NEW_CARDS_ADVANTAGES_TEXT_02',
    }
  ];

  const advantagesItems2 = [
    {
      text: 'DEPOSIT_CREDIT_NEW_CARDS_ADVANTAGES_TEXT_03',
    },
    {
      title: 'DEPOSIT_CREDIT_NEW_CARDS_ADVANTAGES_TITLE_04',
      text: 'DEPOSIT_CREDIT_NEW_CARDS_ADVANTAGES_TEXT_04',
    }
  ];

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  return (
    <div className="deposit-credit-new">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <Tariffs
          items={tariffsData}
          title={'DEPOSIT_CREDIT_NEW_CARDS_TARIFFS_TITLE'}
        />
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
          <Advantages
            items={advantagesItems1}
          />
          <Advantages
            items={advantagesItems2}
          />
        </Tabs>
        <QuestionsAdminNew
          page={page}
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'DEPOSIT_CREDIT_NEW_FAQ_STORYBOOK_TITLE'}
        />
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
        />
        <TextAboveFooterNew
          widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('DEPOSIT_CREDIT_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('DEPOSIT_CREDIT_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
    </div>
  );
}
